import React from 'react';
import 'app/modules/administration/approve-management/approve-management.scss';
import { Table, Button, Modal, Form, Row, Col, Input, ModalHeader, ModalBody, ModalFooter, Spinner, Tooltip } from 'reactstrap';
import { JhiPagination } from 'react-jhipster';
import ComponentDatePicker from 'app/shared/component/ComponentDatePicker';
import { reset, saveUserInfo, handleGetAccountList } from 'app/modules/administration/approve-management/approve-management.reducer';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';
import moment from 'moment';
import { STATUS_TYPES } from 'app/config/constants';
import ModalAccountInfo from './modal-account-info';

export interface IModalLookUpProps extends StateProps, DispatchProps {
  showLookUpModal: boolean;
  handleClose: Function;
}

export interface IModalLookUpState {
  visible: boolean;
  color: string;
  message: string;
  showModal: boolean;
  userType: string;
  isMobile: boolean;
  disableButtonReg: boolean;
  errorMessage: string;
  login: string;
  actionStatus: string;
  currentPage: number;
  filterName: string;
  filterStatus: string;
  mappedFilterStatus: string;
  // fromDate: Date;
  // toDate: Date;
  itemsPerPage: number;
  tooltipOpen: { [key: string]: boolean };
  showAccountInfoModal: boolean;
  searchValue: string;
}

const columnsAccountIND = [
  { title: 'Họ và tên', dataIndex: 'fullName', key: 'name' },
  { title: 'Trạng thái', dataIndex: 'status', key: 'status' },
  { title: 'Số CMND/CCCD', dataIndex: 'userName', key: 'identitycode' },
  { title: 'Ngày cấp tài khoản', dataIndex: 'createdDate', key: 'approvaldate' }
];

const columnsAccountORG = [
  { title: 'Tên tổ chức', dataIndex: 'fullName', key: 'name' },
  { title: 'Trạng thái', dataIndex: 'status', key: 'status' },
  { title: 'Mã tổ chức', dataIndex: 'unitCode', key: 'organizationcode' },
  { title: 'Ngày cấp tài khoản', dataIndex: 'createdDate', key: 'approvaldate' }
];

const mapFilterStatusToStatus = (filterStatus: string | null, type: string): string | null => {
  if (!filterStatus || filterStatus === '') {
    return null;
  }
  const foundKey = Object.keys(STATUS_TYPES[type]).find(key => STATUS_TYPES[type][key] === filterStatus);
  return foundKey || null;
};

export class ModalLookUp extends React.Component<IModalLookUpProps, IModalLookUpState> {
  state: IModalLookUpState = {
    visible: false,
    color: 'danger',
    message: '',
    showModal: false,
    userType: 'IND',
    isMobile: false,
    disableButtonReg: false,
    errorMessage: '',
    login: '',
    actionStatus: '',
    currentPage: 1,
    itemsPerPage: 10,
    filterName: '',
    filterStatus: '',
    mappedFilterStatus: '',
    // fromDate: null,
    // toDate: null,
    tooltipOpen: {},
    showAccountInfoModal: false,
    searchValue: ''
  };

  componentDidMount() {
    const { userType, currentPage, itemsPerPage, filterName, mappedFilterStatus } = this.state;
    window['is_mobile']();
    this.setState({
      isMobile: window['isMobile']
    });
    this.props.handleGetAccountList(userType, currentPage, itemsPerPage, filterName, mappedFilterStatus);
  }

  handleCancel = () => {
    const { showModal } = this.state;
    if (showModal) {
      this.setState({
        showModal: false,
        filterStatus: '',
        mappedFilterStatus: ''
        // fromDate: null,
        // toDate: null
      });
    }
  };

  onFinish = () => {
    const { userType, mappedFilterStatus, currentPage, itemsPerPage, filterName } = this.state;
    if (currentPage !== 1) {
      this.setState({ currentPage: 1 });
    }
    this.props.handleGetAccountList(userType, 1, itemsPerPage, filterName, mappedFilterStatus);
    if (this.state.showModal) {
      this.setState({
        showModal: false,
        filterStatus: '',
        mappedFilterStatus: ''
        // fromDate: null,
        // toDate: null
      });
    }
  };

  // handleChangeFromDate = date => {
  //   this.setState({
  //     fromDate: date
  //   });
  // };

  // handleChangeToDate = date => {
  //   this.setState({
  //     toDate: date
  //   });
  // };

  handlePageChange = (pageNumber: number) => {
    if (this.state.currentPage !== pageNumber) {
      this.setState({ currentPage: pageNumber });
      const { userType, mappedFilterStatus, itemsPerPage, filterName } = this.state;
      this.props.handleGetAccountList(userType, pageNumber, itemsPerPage, filterName, mappedFilterStatus);
    }
  };

  handleUserTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { userType } = this.state;
    if (userType !== event.target.value) {
      this.setState({ userType: event.target.value });
      const { currentPage, mappedFilterStatus, itemsPerPage, filterName } = this.state;
      if (currentPage !== 1) {
        this.setState({ currentPage: 1 });
      }
      this.props.handleGetAccountList(event.target.value, 1, itemsPerPage, filterName, mappedFilterStatus);
    }
  };

  handleItemsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newItemsPerPage = parseInt(event.target.value, 10) || 1;
    if (newItemsPerPage !== this.state.itemsPerPage) {
      this.setState({
        itemsPerPage: newItemsPerPage,
        currentPage: 1
      });
      const { userType, mappedFilterStatus, currentPage, filterName } = this.state;
      this.props.handleGetAccountList(userType, currentPage, newItemsPerPage, filterName, mappedFilterStatus);
    }
  };

  handleSearchChange = event => {
    const filterName = event.target.value.trim().toLowerCase();
    this.setState({ filterName, searchValue: event.target.value });
  };

  handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      const { userType, currentPage, itemsPerPage, mappedFilterStatus, filterName } = this.state;
      if (currentPage !== 1) {
        this.setState({ currentPage: 1 });
      }
      this.props.handleGetAccountList(userType, 1, itemsPerPage, filterName, mappedFilterStatus);
    }
  };

  handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const mappedFilterStatus = mapFilterStatusToStatus(event.target.value, 'ACCOUNT');
    if (this.state.filterStatus !== event.target.value) {
      this.setState({ filterStatus: event.target.value, mappedFilterStatus });
      const { userType, currentPage, itemsPerPage, filterName } = this.state;
      if (currentPage !== 1) {
        this.setState({ currentPage: 1 });
      }
      this.props.handleGetAccountList(userType, 1, itemsPerPage, filterName, mappedFilterStatus);
    }
  };

  handleFilterChangeModal = (event: React.ChangeEvent<HTMLInputElement>) => {
    const mappedFilterStatus = mapFilterStatusToStatus(event.target.value, 'ACCOUNT');
    const { filterStatus } = this.state;
    if (filterStatus !== event.target.value) {
      this.setState({ filterStatus: event.target.value, mappedFilterStatus });
    }
  };

  toggleTooltip = (id: string) => {
    this.setState(prevState => ({
      tooltipOpen: {
        ...prevState.tooltipOpen,
        [id]: !prevState.tooltipOpen[id]
      }
    }));
  };

  handleDetail = (item: any) => {
    const { login } = this.state;
    if (login !== item.userName && this.state.showAccountInfoModal === false) {
      this.setState({ login: item.userName, showAccountInfoModal: true });
    }
  };

  handleAccountInfoClose = () => {
    if (this.state.showAccountInfoModal === true) {
      this.setState({
        showAccountInfoModal: false
      });
      const { userType, currentPage, itemsPerPage, mappedFilterStatus, filterName } = this.state;
      this.props.handleGetAccountList(userType, currentPage, itemsPerPage, filterName, mappedFilterStatus);
    }
  };

  render() {
    const { currentPage, itemsPerPage, userType } = this.state;
    const { accountList } = this.props;
    const indexOfLastItem = currentPage * itemsPerPage;
    const typecolumns = userType === 'IND' ? columnsAccountIND : columnsAccountORG;
    const placeHolder = this.state.userType === 'IND' ? 'Tìm kiếm theo họ và tên' : 'Tìm kiếm theo tên tổ chức';

    const formatDate = dateString => {
      if (!dateString) {
        return '';
      }
      return moment(dateString).format('DD/MM/YYYY');
    };

    return (
      <div>
        <Modal
          id="modalUserExists"
          isOpen={this.props.showLookUpModal}
          size="xl"
          backdrop="static"
          centered={window.location === window.parent.location}
          className="modal-account-info"
        >
          <ModalHeader toggle={this.props.handleClose}>
            <h3 className="font-weight-bold">Tra cứu</h3>
          </ModalHeader>
          <ModalBody>
            <ModalAccountInfo
              showAccountInfoModal={this.state.showAccountInfoModal}
              login={this.state.login}
              userType={userType}
              handleAccountInfoClose={this.handleAccountInfoClose}
            />
            <div className="box-user-search">
              <Row style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '1rem' }}>
                <Col xs="8">
                  <Form inline>
                    <Input type="select" value={userType} onChange={this.handleUserTypeChange}>
                      <option value="IND">Cán bộ CCVC</option>
                      <option value="ORG">Tổ chức</option>
                    </Input>
                    <Input
                      type="text"
                      placeholder={placeHolder}
                      value={this.state.searchValue}
                      onChange={this.handleSearchChange}
                      onKeyDown={this.handleKeyDown}
                      style={{ backgroundColor: '#FAFAFA' }}
                    />
                    <Button
                      color="white"
                      onClick={() => {
                        if (!this.state.showModal) {
                          this.setState({ showModal: true });
                        }
                      }}
                    >
                      <img src={require('app/images/arrow_drop_down.png')} alt="Mở rộng" />
                    </Button>
                  </Form>
                </Col>
                <Col xs="4">
                  <Form inline style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Input
                      type="select"
                      style={{ backgroundColor: '#FAFAFA' }}
                      value={this.state.filterStatus}
                      onChange={this.handleFilterChange}
                    >
                      <option value="">Tất cả</option>
                      <option value={STATUS_TYPES.ACCOUNT.ACTIVATED}>Đang hoạt động</option>
                      <option value={STATUS_TYPES.ACCOUNT.INACTIVE}>Ngưng hoạt động</option>
                    </Input>
                  </Form>
                </Col>
              </Row>
            </div>

            {this.props.loading ? (
              <div className="loading-overlay">
                <Spinner color="primary" />
              </div>
            ) : (
              <div className="box-user-list" style={{ marginTop: '20px', marginBottom: '20px' }}>
                <Table>
                  <thead>
                    <tr>
                      {typecolumns.map(column => (
                        <th key={column.key}>{column.title}</th>
                      ))}
                      <th>Thao tác</th>
                    </tr>
                  </thead>
                  <tbody>
                    {accountList.map(item => (
                      <tr key={item.id}>
                        {typecolumns.map(column => (
                          <td key={column.key}>
                            {column.dataIndex.includes('Date')
                              ? formatDate(item[column.dataIndex])
                              : column.key.includes('status')
                              ? STATUS_TYPES['ACCOUNT'][item[column.dataIndex]]
                              : item[column.dataIndex]}
                          </td>
                        ))}
                        <td>
                          <span>
                            <Button
                              id={`tooltip-Xemchitiết-${item.id}`}
                              color="white"
                              className="mr-1"
                              onClick={() => this.handleDetail(item)}
                            >
                              <img src={require('app/images/eye.png')} />
                            </Button>
                            <Tooltip
                              placement="top"
                              isOpen={this.state.tooltipOpen[`tooltip-Xemchitiết-${item.id}`]}
                              target={`tooltip-Xemchitiết-${item.id}`}
                              toggle={() => this.toggleTooltip(`tooltip-Xemchitiết-${item.id}`)}
                            >
                              Xem chi tiết
                            </Tooltip>
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
            <Row className="box-list-footer fontSize: '1rem', fontWeight: 'normal'">
              <Col xs="6">
                <Form inline>
                  <span style={{ marginRight: '5px' }}>Phần tử mỗi trang</span>
                  <Input type="select" value={itemsPerPage} onChange={this.handleItemsPerPageChange}>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                  </Input>
                </Form>
              </Col>
              <Col xs="6" className="d-flex justify-content-end">
                <Button onClick={() => this.handlePageChange(currentPage - 1)} disabled={this.state.currentPage === 1}>
                  Trang trước
                </Button>
                <Button
                  className="ml-2"
                  onClick={() => this.handlePageChange(currentPage + 1)}
                  disabled={indexOfLastItem >= this.props.totalCount}
                >
                  Trang sau
                </Button>
              </Col>
            </Row>

            <Modal isOpen={this.state.showModal} toggle={this.handleCancel}>
              <ModalHeader toggle={this.handleCancel}>Tìm kiếm nâng cao</ModalHeader>
              <ModalBody>
                <Row>
                  <Col xs="4">
                    Trạng thái:
                    <Input type="select" value={this.state.filterStatus} onChange={this.handleFilterChangeModal}>
                      <option value="">Tất cả</option>
                      <option value={STATUS_TYPES.ACCOUNT.ACTIVATED}>Đang hoạt động</option>
                      <option value={STATUS_TYPES.ACCOUNT.INACTIVE}>Ngưng hoạt động</option>
                    </Input>
                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    <div className="form-group">
                      <ComponentDatePicker
                        name="fromDate"
                        value={this.state.fromDate}
                        required={false}
                        handleChange={this.handleChangeFromDate}
                        label="Thời gian cấp tài khoản từ:"
                        placeHolder="dd/mm/yyyy"
                        readOnly={false}
                      />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <ComponentDatePicker
                        name="toDate"
                        value={this.state.toDate}
                        required={false}
                        handleChange={this.handleChangeToDate}
                        label="Thời gian cấp tài khoản đến:"
                        placeHolder="dd/mm/yyyy"
                        readOnly={false}
                      />
                    </div>
                  </Col>
                </Row> */}
              </ModalBody>
              <ModalFooter>
                <Button className="btn-confirm" onClick={this.onFinish}>
                  Tìm kiếm
                </Button>
              </ModalFooter>
            </Modal>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  loading: storeState.approveManagement.loading,
  currentLocale: storeState.locale.currentLocale,
  config: storeState.applicationProfile.config,
  accountList: storeState.approveManagement.accountList,
  totalCount: storeState.approveManagement.totalCount
});
const mapDispatchToProps = {
  handleGetAccountList,
  saveUserInfo,
  reset
};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalLookUp);
